import {useTranslation} from "react-i18next";
import {STATUS_PAID_INVOICE, STATUS_SENT_TO_INVOICE, STATUS_TO_INVOICE} from "../../finessecurity/component/Constants";
import {useTheme} from "@mui/material";


export const useFinesStatusValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'fines'});
    const theme = useTheme();
    const getFinesStatusColor = (status: number) => {
        switch (status) {
            case STATUS_TO_INVOICE: return theme.palette.secondary.transparent;
            case STATUS_SENT_TO_INVOICE: return theme.palette.warning.transparent;
            case STATUS_PAID_INVOICE: return theme.palette.success.light;
            //warning.transparent secondary.transparent
        }
    };
    const getFinesStatusValues = (status: number) => {
            switch (status) {
                case STATUS_TO_INVOICE: return t('status.toInvoice');
                case STATUS_SENT_TO_INVOICE: return t('status.sentToInvoice');
                case STATUS_PAID_INVOICE: return t('status.billed');

                default : return '-'
            }
    };

    return {
        getFinesStatusValues, getFinesStatusColor
    }
}